export var EsignFormTabs;
(function (EsignFormTabs) {
    EsignFormTabs["Recipients"] = "recipients";
    EsignFormTabs["Activity"] = "activity";
    EsignFormTabs["Settings"] = "settings";
})(EsignFormTabs || (EsignFormTabs = {}));
